/* global globalThis */

const BUILDER_CONTENT_SELECTOR = "[builder-content-id]";

export function getBuilderContentWrapper(rootElement) {
    if (!rootElement || typeof rootElement.closest !== "function") {
        return null;
    }

    return rootElement.closest(BUILDER_CONTENT_SELECTOR);
}

export function isBuilderVariantActive(rootElement) {
    const wrapper = getBuilderContentWrapper(rootElement);
    if (!wrapper) {
        return true;
    }

    if (
        wrapper.hasAttribute("hidden") ||
        wrapper.getAttribute("aria-hidden") === "true"
    ) {
        return false;
    }

    if (typeof globalThis.getComputedStyle === "function") {
        return globalThis.getComputedStyle(wrapper).display !== "none";
    }

    return true;
}

/**
 * Runs startCallback once the component belongs to the active Builder variant.
 * Components outside Builder are treated as active immediately.
 */
export function startWhenBuilderVariantActive(rootElement, startCallback) {
    const wrapper = getBuilderContentWrapper(rootElement);
    let stopped = false;
    let started = false;
    let animationFrameHandle = null;
    let observer = null;

    const startIfActive = () => {
        animationFrameHandle = null;

        if (stopped || started || !isBuilderVariantActive(rootElement)) {
            return;
        }

        started = true;
        observer?.disconnect();
        observer = null;
        startCallback();
    };

    const scheduleCheck = () => {
        if (stopped || started || animationFrameHandle !== null) {
            return;
        }

        if (typeof globalThis.requestAnimationFrame === "function") {
            animationFrameHandle = globalThis.requestAnimationFrame(startIfActive);
            return;
        }

        animationFrameHandle = true;
        Promise.resolve().then(startIfActive);
    };

    if (wrapper && typeof globalThis.MutationObserver === "function") {
        observer = new globalThis.MutationObserver(scheduleCheck);
        observer.observe(wrapper, {
            attributes: true,
            attributeFilter: ["hidden", "aria-hidden", "class", "style"],
        });
    }

    scheduleCheck();

    return () => {
        stopped = true;
        observer?.disconnect();
        observer = null;

        if (
            animationFrameHandle !== null &&
            animationFrameHandle !== true &&
            typeof globalThis.cancelAnimationFrame === "function"
        ) {
            globalThis.cancelAnimationFrame(animationFrameHandle);
        }

        animationFrameHandle = null;
    };
}
